var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfiledropdownCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "group",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.149,
    height: 17.536,
    viewBox: "0 0 21.149 17.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46932",
    "data-name": "Group 46932",
    transform: "translate(0 7.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46931",
    "data-name": "Group 46931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54353",
    "data-name": "Path 54353",
    d: "M18.051,231.269h-2.07a3.09,3.09,0,0,0-.814.109,3.1,3.1,0,0,0-2.762-1.7H8.745a3.1,3.1,0,0,0-2.762,1.7,3.09,3.09,0,0,0-.814-.109H3.1a3.1,3.1,0,0,0-3.1,3.1v3.309a1.861,1.861,0,0,0,1.859,1.859H19.29a1.861,1.861,0,0,0,1.859-1.859v-3.309A3.1,3.1,0,0,0,18.051,231.269Zm-12.4,1.509V238.3H1.859a.62.62,0,0,1-.62-.62v-3.309A1.861,1.861,0,0,1,3.1,232.508h2.07a1.853,1.853,0,0,1,.486.065C5.65,232.641,5.647,232.709,5.647,232.778Zm8.616,5.518H6.886v-5.518a1.861,1.861,0,0,1,1.859-1.859H12.4a1.861,1.861,0,0,1,1.859,1.859Zm5.647-.62a.62.62,0,0,1-.62.62H15.5v-5.518c0-.069,0-.137-.008-.2a1.854,1.854,0,0,1,.486-.065h2.07a1.861,1.861,0,0,1,1.859,1.859Z",
    transform: "translate(0 -229.68)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46934",
    "data-name": "Group 46934",
    transform: "translate(1.38 3.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46933",
    "data-name": "Group 46933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54354",
    "data-name": "Path 54354",
    d: "M36.167,126.5a2.753,2.753,0,1,0,2.753,2.753A2.756,2.756,0,0,0,36.167,126.5Zm0,4.267a1.514,1.514,0,1,1,1.514-1.514A1.515,1.515,0,0,1,36.167,130.771Z",
    transform: "translate(-33.414 -126.504)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46936",
    "data-name": "Group 46936",
    transform: "translate(6.897 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46935",
    "data-name": "Group 46935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54355",
    "data-name": "Path 54355",
    d: "M170.64,43.729a3.678,3.678,0,1,0,3.678,3.678A3.682,3.682,0,0,0,170.64,43.729Zm0,6.116a2.439,2.439,0,1,1,2.439-2.439A2.441,2.441,0,0,1,170.64,49.845Z",
    transform: "translate(-166.962 -43.729)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46938",
    "data-name": "Group 46938",
    transform: "translate(14.263 3.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46937",
    "data-name": "Group 46937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54356",
    "data-name": "Path 54356",
    d: "M348.047,126.5a2.753,2.753,0,1,0,2.753,2.753A2.756,2.756,0,0,0,348.047,126.5Zm0,4.267a1.514,1.514,0,1,1,1.514-1.514A1.515,1.515,0,0,1,348.047,130.771Z",
    transform: "translate(-345.294 -126.504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiledropdownCommunity);
export default __webpack_public_path__ + "static/media/profiledropdown-community.f5e3e47cc5a7f97ada407c2cc6c0e9ad.svg";
export { ForwardRef as ReactComponent };